export interface Report{
    url: string;
}